module.exports = __webpack_public_path__ + "8efc4a49da77924e42795a015788d518.pdf";